module.exports = __webpack_public_path__ + "vg.svg?66607bf807f05cc6ff7cbee92f4c1ae0";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/vg.svg
// module id = 1221
// module chunks = 27